import { ATable } from '@congacommerce/core';
import { EglBasePav } from './egl-base-pav';

@ATable({
    sobjectName: 'Apttus_Config2__AssetAttributeValue__c',
    aqlName: null,
})
export class EglAssetAttributeValue extends EglBasePav {}
